import React from "react";
import DynamicEditForm from "../../components/DynamicEditForm/DynamicEditForm";
import { getStoredData } from "../../json/fecthData";

const RoleManagementEdit = () => {
  // Fetch stored role data
  const roleData = getStoredData()?.[1] || {}; // Ensure roleData is an object

  return (
    <div>
      <h2>Edit {roleData.TitleRole} Management</h2>
      <DynamicEditForm
        fields={roleData.AdminRole} // Pass dynamic fields
        apiUrl={roleData.ApiRole} // Use correct API URL
        successRedirect={roleData.RedirectAdminRole} // Redirect after successful update
      />
    </div>
  );
};

export default RoleManagementEdit;
